<template>
  <v-dialog :value="value" width="430" persistent>
    <v-card>
      <v-card-title>
        Confirm Feature Position Edit
      </v-card-title>
      <v-card-text>
        {{ confirmText }}
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="grey darken-1" text :class="body" @click="$emit('cancel')">
          Cancel
        </v-btn>
        <v-btn color="warning" :class="body" @click="confirm">
          Continue
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { displayHelpers } from '@/mixins/display-helpers'
export default {
  name: 'FeatureEditConfirm',
  props: {
    value: Boolean,
    targetFeature: Object
  },
  mixins: [displayHelpers],
  computed: {
    confirmText() {
      return `Change this feature position to ${this.targetFeature.position.name} and move "${this.targetFeature.feature_text}", to Page 7?`
    }
  },
  methods: {
    confirm() {
      this.$emit('confirmAction')
    }
  }
}
</script>